export default {"src":"/_next/static/media/generic-residential-icon-selected.4f6fa4b0.svg","height":85,"width":105,"blurWidth":0,"blurHeight":0};